<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

.item{
  display: grid;
  grid-template-columns: 40px auto;
  color: white;
  margin: 10px 40px 0 40px;
  padding: 10px 0;
}
.check{
  grid-column: 1;
  text-align: center;
}
.text{
  grid-column: 2;
}

button.show-all{
  border: none;
  background-color: rgba(255,255,255,0.5);
  color: black;
  margin: 20px 0 0 80px;
  width: auto;
  font-size: 20px;
}
button.show-all:hover{
  border: none;
  background-color: rgba(255,255,255,0.8);
  color: black;
}

.looking-for{
  background-color: rgba(255,255,255,0.5);
  color: black;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>Who are you looking to meet?</h3>
  
{#each lookingForOther as item}
  {#if showAllHelper(item, showAll)}
    <div class="item { lookingFor.includes(item.i) ? 'looking-for' : '' }" on:click="{ () => selectHelper(item.i) }">
      <div class="check">
        
        {#if lookingFor.includes(item.i)}
          <i class="icon-check"></i>
        {/if}
        
      </div>
      <div class="text">{item.t}</div>
    </div>
  {/if}
{/each}

{#if !showAll}
  <button class="show-all" on:click="{ () => {showAll = true; dispatch('showAll') } }">Show All Identities</button>
{/if}

<div class="space small">Select all that apply</div>

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Genders from "../../helpers/Genders.js";
const lookingForOther = Genders.lookingForOther;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

export let show = false;
export let me = null;

let showAll = false;
let lookingFor = [];


$:{
  if (me) set();
}


function set() {
  lookingFor = JSON.parse( JSON.stringify( me.lookingFor ) );
}


function selectHelper(item) {
  let index = lookingFor.indexOf(item);
  if (index != -1) {
    lookingFor.splice(index, 1);
  } else {
    lookingFor.push(item);
  }
  lookingFor = lookingFor;
  check();
}


function showAllHelper(item) {
  if (showAll == false && item.d == true) {
    return true;
  } else if (showAll == true) {
    return true;
  }
  
  return false;
}


function check() {
  try {
    Validate.isArrayFilled(lookingFor);
  } catch (e) {
    console.log("error:", e);
  }
}


export const save = async () => {
  if (lookingFor != me.lookingFor) {
    me.lookingFor = lookingFor;
    await profile.updateMe( { updateShare: true } );
  }
}


</script>